import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { Box, Stack } from "@mui/material";
import { styled } from "@mui/material/styles";
import { Button, paletteVar, Typography } from "@platform/design-system";
import { JSX } from "react";

interface Props {
  title: string;
  subtitle: string;
  buttonText: string;
  buttonAction: VoidFunction;
}

function SuccessMessage({
  title,
  subtitle,
  buttonText,
  buttonAction,
}: Props): JSX.Element {
  return (
    <SuccessMsg justifyContent="center" alignItems="center" spacing={2}>
      <Box pb={2}>
        <CheckCircleOutlineIcon />
      </Box>
      <Typography variant="display-small">{title}</Typography>
      <Typography variant="header-medium">{subtitle}</Typography>
      <Box pt={4}>
        <Button variant="primary" size="lg" onClick={buttonAction}>
          {buttonText}
        </Button>
      </Box>
    </SuccessMsg>
  );
}

export const SuccessMsg = styled(Stack)(() => ({
  "& .MuiSvgIcon-root": {
    fontSize: "5rem",
    color: paletteVar("success-main", "#bcda81"),
  },
})) as unknown as typeof Stack;

export default SuccessMessage;
